export default function ProfileButton({ name, showCompanyLink, onLogout }) {
    return (
        <div className="header__drop header__logger-drop">
            <a role="button" className="header__drop-link">
                <i className="icon-user2"></i>
                {__('menu.profile')}
            </a>
            <div className="header__dropdown">
                <ul className="header__dropdown-menu">
                    <li><a href="/profile">{name}</a></li>
                    {showCompanyLink && <li><a href="/profile/company">{__('menu.company')}</a></li>}
                    <li><a role="button" onClick={onLogout}>{__('menu.logout')}</a></li>
                </ul>
            </div>
        </div>
    )
}
